import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../img/LogoEMEwhite.svg";

const AnimatedRoutes = () => {
  const [show, setShow] = useState(true); // 👈 empieza visible

  useEffect(() => {
    // ⏱️ Pausa + salida
    const totalTime = 1200; // tiempo antes de irse

    const timeout = setTimeout(() => setShow(false), totalTime);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={false} // 👈 sin animación de entrada
          animate={{ opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }} // 👈 solo salida hacia arriba
          transition={{ duration: 0.6, ease: "easeInOut" }}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "#000",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            pointerEvents: "none",
          }}
        >
          <motion.img
            src={logo}
            alt="Logo EME"
            initial={false}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            style={{ width: "120px" }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
